import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { isLoadingTwitchLogin, loginTwitchUser, userSelector } from 'src/store/auth';

import { CustomButton, Loader } from 'src/components';
import { ROUTE } from 'src/constants';

import './twitchCallback.scss';

export const TwitchCallback = () => {
  const { t } = useTranslation('twitch_callback');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const code = searchParams.get('code');
  const error = searchParams.get('error');
  const state = searchParams.get('state');

  const user = useSelector(userSelector);
  const isLoading = useSelector(isLoadingTwitchLogin);

  useEffect(() => {
    if (error || !state || !code) {
      navigate(ROUTE.MAIN);
    }
  }, [navigate, error, state, code]);

  useEffect(() => {
    if (code && state) {
      dispatch(loginTwitchUser({ code, state, navigate }));
    }
  }, [dispatch, navigate, code, state]);

  const welcomeMessage = t('welcome', { name: user?.display_name });

  return (
    <div className="twitch-callback">
      <div className="twitch-callback__card">
        <>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <h2>{welcomeMessage}</h2>

              <CustomButton title={t('cta')} component="link" to={ROUTE.DASHBOARD.MAIN} />
            </>
          )}
        </>
      </div>
    </div>
  );
};
